import React from "react";
import { Parallax } from "react-parallax";
import { useTheme } from "@mui/material";

export default function Home() {
    const theme = useTheme();
    return (
        <div>
            <Parallax
                bgImage="/static/stabbur.jpg"
                style={{
                    height: 700,
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2),
                    color: "white",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: 500,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <h1 style={{ textAlign: "center" }}>Reshjem Gård</h1>
                    <h2>Notodden</h2>
                </div>
            </Parallax>
        </div>
    );
}
